import * as React from "react";
import { observer } from "mobx-react";
import { Button } from "./../Button";
import { Strings } from "../../Stores/StringsStore";

@observer
export class ZoomInButton extends Button {

	render() {
		return <Button {...this.props} title={this.props.title ? this.props.title : Strings.reader.zoomInButtonTooltip}>
			<i>
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
					<path d="M32,29.17L21.77,18.95a12,12,0,1,0-2.83,2.83L29.17,32ZM14,20H10V14H4V10h6V4h4v6h6v4H14v6Z" />
				</svg>
			</i>
		</Button>;
	}
}
